module.exports = __webpack_public_path__ + "img/human.5bbec73b.svg";